import React from 'react';
import { connect } from 'react-redux';

import store from '../store';

const { dispatch } = store;

class SobjectFieldList extends React.Component {
    render() {
        const { fields, sobjectName, idx, selected } = this.props;

        if (fields == null) {
            return <div className="spinner is-active" />
        }

        return (
            <select className="value gaddon-setting gaddon-select" value={selected} onChange={e => {
                this.props.onChange(e);
            }}>
                <option value=""></option>
                {
                    fields.map((field, idx) => {
                        return (
                            <option key={`${field.name}_${idx}`} value={field.name}>{field.label}</option>
                        )
                    })
                }
            </select>
        );
    }
}

const mapStateToProps = function (store) {
    return {
        sobjectName: store.metaState.get('sobject').get('name'),
        fields: store.metaState.get('sobject').get('fields') ? store.metaState.get('sobject').get('fields').toJS() : null
    };
};

export default connect(mapStateToProps)(SobjectFieldList);
